import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { clearUser, selectUser, selectIsLoggedIn } from '../redux/slices/user';
import { logout } from '../services/auth/auth.service';
import { googleSignOut } from '../services/auth/google-auth.service';
import { facebookSignOut } from '../services/auth/facebook-auth.service';
import { appleSignOut } from '../services/auth/apple-auth.service';
import { LOGON_METHOD } from '../components/entities/sys-constants';

export const useLogout = (onComplete?: () => void) => {
    const dispatch = useAppDispatch();
    const userInfo = useAppSelector(selectUser);
    const isLoggedIn = useAppSelector(selectIsLoggedIn);

    const logoutByMethod = (method: string, accessToken?: string, refreshToken?: string) => {
        switch (method) {
            case LOGON_METHOD.NATIVE:
                if (accessToken && refreshToken) {
                    logout(accessToken, refreshToken);
                }
                break;
            case LOGON_METHOD.GOOGLE:
                googleSignOut();
                break;
            case LOGON_METHOD.FACEBOOK:
                facebookSignOut();
                break;
            case LOGON_METHOD.APPLE:
                appleSignOut();
                break;
            default:
                break;
        }
    };

    const handleLogout = () => {
        if (isLoggedIn && userInfo) {
            dispatch(clearUser());
            logoutByMethod(userInfo.logonMethod, userInfo.accessToken, userInfo.refreshToken);
        }

        onComplete && onComplete();
    };

    return { handleLogout };
};

